export const translations = {
  en: {
    stats: {
      title: "Our Reach Across Sangli",
      divisions: "Divisions",
      districts: "Districts",
      branchOffices: "Branch Offices",
      selectDivision: "Select Division",
      selectDistrict: "Select District",
      selectBranchOffice: "Select Branch Office",
      ApplicationReceived: "Application Received",
      ApplicationApproved: "Application Approved",
      ApplicationRejected: "Application Rejected",
      MaximumDataken: "Maximum Day's taken ",
      MinimumDaytaken: "Minimum Day's taken",
      AvgTimeDisposule: "Avg. time for Disposal",
      CompliancePercentage: "Compliance percentage",
      "Service Charges": "Service Charges"

    }
  },
  mr: {
    stats: {
      title: "महाराष्ट्रभर व्याप्ती",
      divisions: "विभाग",
      districts: "जिल्हे",
      branchOffices: "शाखा कार्यालये",
      selectDivision: "विभाग निवडा",
      selectDistrict: "जिल्हा निवडा",
      selectBranchOffice: "शाखा कार्यालय निवडा",
      ApplicationReceived: "अर्ज प्राप्त",
      ApplicationApproved: "मंजूर अर्ज",
      ApplicationRejected: "अर्ज नाकारले",
      MaximumDataken: "कमाल कालावधी",
      MinimumDaytaken: "किमान कालावधी",
      AvgTimeDisposule: "सेवा प्राप्तीचा सरासरी वेळ",
      CompliancePercentage: "अनुपालन टक्केवारी",
      "Service Charges": "सेवा शुल्क"
    }
  }

};